/* global tv */
import { Subscription } from 'rxjs';
import { filter, skip } from 'rxjs/operators';
import * as FreewheelAdapter from 'youbora-adapter-freewheel';
import { NEW_CONTENT } from '../../types';
import { UNKNOWN } from '../../utils/types';

export const AdAdapter = FreewheelAdapter.extend({
  getAudioEnabled() {
    return !this.player.select(({ volume }) => volume.muted);
  },

  getIsSkippable() {
    return false;
  },

  getIsFullscreen() {
    return this.player.select(({ ui }) => ui.isFullscreen);
  },

  getTitle() {
    // Override FreewheelAdapter getTitle to avoid error when capping is active because this.titles is empty
    if (this.titles?.[(this.plugin.requestBuilder.lastSent.adNumber || 1) - 1]) {
      return this.titles[(this.plugin.requestBuilder.lastSent.adNumber || 1) - 1]._adId; /* eslint-disable-line */
    }

    return UNKNOWN;
  },

  getSlots() {
    // eslint-disable-next-line no-underscore-dangle
    const slots = this.player.freewheelController.slots$._buffer[0];
    // eslint-disable-next-line no-underscore-dangle
    return slots;
  },

  registerListeners() {
    this.subscriptions = new Subscription();

    this.canRemoveListeners = true;
    this.events = (window.tv && tv.freewheel?.SDK) || {};
    this.monitorPlayhead(true, false);

    [
      this.player.freewheelController.slotStartedEvent$.subscribe((evt) => this.slotListener(evt)),
      this.player.freewheelController.slotEndedEvent$.subscribe((evt) => this.closeListener(evt)),
      this.player.freewheelController.errorEvent$.subscribe((evt) => this.errorListener(evt)),
      this.player.freewheelController.adEvent$.subscribe((evt) => this.logListener(evt)),
      this.player.events$.pipe(filter((evt) => evt?.name === NEW_CONTENT), skip(1)).subscribe(() => this.changeVideo())
    ].forEach((subs) => this.subscriptions.add(subs));
  },

  unregisterListeners() {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop();
    if (this.player && this.refs) this.subscriptions.unsubscribe();
  }
});
